<div class="row">
    <div class="col-xl-4">
        <div class="card p-5 mb-5">
            <div class="card-badges">
                <span class="badge badge-pill shadow-none badge-danger">27</span>
            </div>
            <div class="bg-arielle-smile text-center text-white font-size-xl d-50 rounded">
                <fa-icon [icon]="['far', 'map']"></fa-icon>
            </div>
            <h3 class="font-size-lg font-weight-bold mt-4">Sales statistics</h3>
            <p class="text-black-50 mt-2">
                We've included only the most popular solutions included ...
            </p>
            <a [routerLink]="" class="btn btn-outline-first mt-1">
                <span class="btn-wrapper--label">View live preview</span>
                <span class="btn-wrapper--icon">
                    <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                </span>
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card p-5 mb-5">
            <div class="card-badges">
                <span class="badge badge-pill shadow-none badge-warning mr-1">Promo</span>
                <span class="badge badge-pill shadow-none badge-info">Special</span>
            </div>
            <div class="bg-night-sky text-center text-white font-size-xl d-50 rounded">
                <fa-icon [icon]="['far', 'chart-bar']"></fa-icon>
            </div>
            <h3 class="font-size-lg font-weight-bold mt-4">Generated reports</h3>
            <p class="text-black-50 mt-2">
                Mosaic, the first graphical browser, is introduced to the ...
            </p>
            <a [routerLink]="" class="btn btn-outline-first mt-1">
                <span class="btn-wrapper--label">View live preview</span>
                <span class="btn-wrapper--icon">
                    <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                </span>
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card p-5 mb-5">
            <div class="card-badges">
                <span class="badge badge-pill shadow-none badge-neutral-danger text-danger">Overdue</span>
            </div>
            <div class="bg-vicious-stance text-center text-white font-size-xl d-50 rounded">
                <fa-icon [icon]="['far', 'object-group']"></fa-icon>
            </div>
            <h3 class="font-size-lg font-weight-bold mt-4">Pricing plans</h3>
            <p class="text-black-50 mt-2">
                Bill Clinton's presidential scandal makes it online for the ...
            </p>
            <a [routerLink]="" class="btn btn-outline-first mt-1">
                <span class="btn-wrapper--label">View live preview</span>
                <span class="btn-wrapper--icon">
                    <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                </span>
            </a>
        </div>
    </div>
</div>